import Paper from '@mui/material/Paper'

import PageContainer from '@/components/ui/containers/PageContainer'
import { PatientProfileForm } from '@/features/patient/patient-profile-form'
import { useOfflineMode } from '@/providers/OfflineModeProvider'
import { OfflineInitializing, OfflineStatusIndicator } from '@/shared/offline'

import { useCreateOfflinePatient } from '../model/useCreateOfflinePatient'

type OfflineCreatePatientPageProps = {}

export function OfflineCreatePatientPage(props: OfflineCreatePatientPageProps) {
  const { isOfflineDatabaseReady } = useOfflineMode()

  const { onSubmit } = useCreateOfflinePatient()

  if (!isOfflineDatabaseReady) {
    return <OfflineInitializing />
  }

  return (
    <PageContainer>
      <OfflineStatusIndicator />
      <Paper sx={{ mt: '15px', p: '30px' }}>
        <PatientProfileForm mode="create" onSubmit={onSubmit} />
      </Paper>
    </PageContainer>
  )
}
